module.exports = __webpack_public_path__ + "static/media/vanamali.6503045e.png";